import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSlider from "./components/HeroSlider";
import ProductsSection from "./components/ProductsSection";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 flex flex-col">
        <HeroSlider />
        <ProductsSection />
      </main>
      <Footer />
    </div>
  );
}
